import { assertEvent, assign } from 'xstate5';

import { type BundleMachineAction, type SelectedProduct } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Notes the default ingredients a selected product will be added without, and
 * how leaving them off changes its price.
 */
export const storeOutOfStockIngredients: BundleMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, 'customization.out-of-stock-ingredients-found');

  const { actorId: selectionId, ingredientNames, netPrice } = event;

  return {
    selectedProducts: context.selectedProducts.map((selectedProduct) =>
      markOutOfStockIngredients({ selectedProduct, selectionId, ingredientNames, netPrice }),
    ),
  };
});

// ─── Helpers ─────────────────────────────────────────────────────────────────

function markOutOfStockIngredients(params: MarkOutOfStockIngredientsParams): SelectedProduct {
  const { selectedProduct, selectionId, ingredientNames, netPrice } = params;

  if (selectedProduct.selectionId !== selectionId) return selectedProduct;

  return { ...selectedProduct, outOfStockIngredientNames: ingredientNames, netPrice };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type MarkOutOfStockIngredientsParams = {
  selectedProduct: SelectedProduct;
  selectionId: string;
  ingredientNames: string;
  netPrice: number;
};
